import React, { useEffect, useState } from "react";

const BASE_URL = "/v1";

function LowStockAlert({ user, onError }) {
    const [lowStockItems, setLowStockItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [categoryFilter, setCategoryFilter] = useState("ALL");

    // collapsed by default
    const [open, setOpen] = useState(false);

    useEffect(() => {
        fetchLowStock();
    }, []);

    const fetchLowStock = async () => {
        try {
            setLoading(true);

            const token = localStorage.getItem("token");

            const res = await fetch(`${BASE_URL}/stocks/low-stock`, {
                headers: {
                    Authorization: "Bearer " + token
                }
            });

            const data = await res.json();

            const normalized = (data || []).map(item => ({
                ...item,
                product: {
                    ...item.product,
                    category: item.product?.category?.toLowerCase()
                }
            }));

            setLowStockItems(normalized);

        } catch (err) {
            console.error("Low stock fetch failed", err);
            onError?.("danger", "Cannot load low stock items right now. Please check the backend server.");
        } finally {
            setLoading(false);
        }
    };

    if (user?.role !== 3) return null;
    if (!loading && lowStockItems.length === 0) return null;

    const formatCategory = (cat) =>
        cat ? cat.charAt(0).toUpperCase() + cat.slice(1) : "";

    const categories = [
        "ALL",
        ...new Set(
            lowStockItems
                .map(item => item.product?.category)
                .filter(Boolean)
        )
    ];

    const filteredItems = lowStockItems.filter(item => {
        if (categoryFilter === "ALL") return true;
        return item.product?.category === categoryFilter;
    });

    return (
        <div className="card mb-3 border-danger shadow-sm overflow-hidden">
            <div
                className="card-header d-flex justify-content-between align-items-center"
                style={{
                    cursor: "pointer",
                    background: "linear-gradient(135deg, rgba(248, 113, 113, 0.18), rgba(255, 255, 255, 0.96))",
                    color: "#7f1d1d",
                    borderBottom: "1px solid rgba(248, 113, 113, 0.18)"
                }}
                onClick={() => setOpen(!open)}
            >
                <strong>Low Stock Alert ({filteredItems.length})</strong>

                <div className="d-flex gap-2 align-items-center">
                    <select
                        className="form-select form-select-sm"
                        value={categoryFilter}
                        onChange={(e) => setCategoryFilter(e.target.value)}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {categories.map((cat, i) => (
                            <option key={i} value={cat}>
                                {cat === "ALL"
                                    ? "All"
                                    : formatCategory(cat)}
                            </option>
                        ))}
                    </select>

                    <button
                        className="btn btn-sm btn-dark"
                        onClick={(e) => {
                            e.stopPropagation();
                            fetchLowStock();
                        }}
                    >
                        Refresh
                    </button>

                    <span
                        style={{
                            fontSize: "18px",
                            fontWeight: "bold",
                            color: "#7f1d1d"
                        }}
                    >
                        {open ? "▲" : "▼"}
                    </span>
                </div>
            </div>

            {open && (
                <div
                    className="card-body p-2"
                    style={{ maxHeight: "220px", overflowY: "auto" }}
                >
                    {loading ? (
                        <div className="text-center p-2">
                            Loading...
                        </div>
                    ) : (
                        <table className="table table-sm table-bordered mb-0">
                            <thead className="table-light sticky-top">
                                <tr>
                                    <th>Product</th>
                                    <th>Qty</th>
                                    <th>Min</th>
                                </tr>
                            </thead>

                            <tbody>
                                {filteredItems.length === 0 ? (
                                    <tr>
                                        <td
                                            colSpan="3"
                                            className="text-center text-muted"
                                        >
                                            No items found
                                        </td>
                                    </tr>
                                ) : (
                                    filteredItems.map((item, idx) => (
                                        <tr key={item.id || idx}>
                                            <td>
                                                <div>
                                                    <strong>
                                                        {item.product?.barcode}
                                                    </strong>
                                                </div>

                                                <div>
                                                    {item.product?.name}

                                                    {item.product?.category && (
                                                        <span
                                                            className="badge bg-secondary ms-2"
                                                            style={{ fontSize: "10px" }}
                                                        >
                                                            {formatCategory(
                                                                item.product.category
                                                            )}
                                                        </span>
                                                    )}
                                                </div>
                                            </td>

                                            <td className="text-danger fw-bold">
                                                {item.quantity}
                                            </td>

                                            <td>
                                                {item.minQuantity}
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    )}
                </div>
            )}
        </div>
    );
}

export default LowStockAlert;
